import React from "react";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import SidebarNavigationLink from "components/layout/RightSidebar/SidebarNavigationLink";
import SidebarEventDefinitionDetails from "components/event-definitions/SidebarEventDefinitionDetails";
const EventDefinitionLink = ({ title, id }) => {
  const { permissions } = useCurrentUser();
  if (!title) {
    return /* @__PURE__ */ React.createElement("em", null, id);
  }
  if (isPermitted(permissions, `eventdefinitions:read:${id}`)) {
    return /* @__PURE__ */ React.createElement(SidebarNavigationLink, { content: SidebarEventDefinitionDetails(id) }, title);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, title);
};
export default EventDefinitionLink;
